/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Transition relative to previous step
 */
export const Transition = {
  Steady: "steady",
  RampingUp: "ramping_up",
  RampingDown: "ramping_down",
} as const;
/**
 * Transition relative to previous step
 */
export type Transition = OpenEnum<typeof Transition>;

/**
 * MPC-determined state for a single compressor at a point in time
 */
export type CompressorForecastState = {
  /**
   * Transition relative to previous step
   */
  transition: Transition;
  /**
   * Stage value: 0=unavailable, 1=off, 2=on, 3=trim
   */
  value: number;
};

/** @internal */
export const Transition$inboundSchema: z.ZodType<
  Transition,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(Transition);

/** @internal */
export const CompressorForecastState$inboundSchema: z.ZodType<
  CompressorForecastState,
  z.ZodTypeDef,
  unknown
> = z.object({
  transition: Transition$inboundSchema,
  value: types.number(),
});

export function compressorForecastStateFromJSON(
  jsonString: string,
): SafeParseResult<CompressorForecastState, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompressorForecastState$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompressorForecastState' from JSON`,
  );
}
